import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import AwsImageInline from '../../../../../components/InlineEdit/AwsImageInline';
import attendanceServices from '../attendanceServices';
import moment from 'moment';


function UpdatePunchForm({data,callBack, employeeId }) {

    const {AppAlert} = useAlert();
    const {masters,employeeDD,getDDDataById} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {        
        employeeId:employeeId,
        inTime:moment().format("YYYY-MM-DD 09:00:00"),
        outTime:moment().format("YYYY-MM-DD 18:00:00"),
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            employeeId:data.employeeId,
            inTime: data.inTime,
            outTime:data.outTime
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        //employeeId:Yup.string().required("Required"),
        inTime:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        let payload = {...values};
        payload.inTime = moment(values.inTime).format("YYYY-MM-DD HH:mm:ss")
        payload.outTime = moment(values.outTime).format("YYYY-MM-DD HH:mm:ss")        
           
        attendanceServices.updatePunch(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })

    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add Punch</button>
                </Tooltip>
            }
            {data &&
                <>
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
                {data.updatedBy != null && 
                    <div>
                        <span className='fw-bold'>Updated By :</span> {getDDDataById(employeeDD,data.updatedBy).label}
                    </div>
                }
                </>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Update Punch"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                {/*
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Employee " name="employeeId"  
                                                        options={employeeDD} multiple={false} 
                                                    />
                                                </div>
                                                */}

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="datetime-local" 
                                                        label="In Time" name="inTime" 
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="datetime-local" 
                                                        label="Out Time" name="outTime" 
                                                    />
                                                </div>
                                                
                                            </div>

                                            
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default UpdatePunchForm